import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DatabaseService } from '@app/database/database.service';
import { FilterService, Message } from 'primeng/api';
import { ConnectionService } from 'ng-connection-service';
import { Subscription } from 'rxjs';
import { Sidebar } from 'primeng/sidebar';
import { ExamsService } from '@shared/views/exams/exams.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsFilterService } from '@shared/components/exams-filter/exams-filter.service';
import { ActivatedRoute, Params } from '@angular/router';
import { UserEmailService } from '@shared/services/user-email.service';

@Component( {
  selector: 'app-exams',
  templateUrl: './exams.component.html',
  styleUrls: [ './exams.component.scss' ],
} )
export class ExamsComponent implements OnInit, OnDestroy {
  periodicosContent: any[] = [];
  reevaluacionContent: any[] = [];
  cargadosContent: any[] = [];
  enviarContent: any[] = [];

  periodicosContentTodos: any[] = [];
  reevaluacionContentTodos: any[] = [];
  periodicosFiltradosContentTodos: any[] = [];
  reevaluacionFiltradosContentTodos: any[] = [];
  cargadosContentTodos: any[] = [];
  enviarContentTodos: any[] = [];

  motivosCierre: any[] = [];
  displaySpinnerPeriodicos = true;
  displaySpinnerReevaluacion = true;
  displaySpinnerCargados = true;
  msgs: Message[];
  display: boolean;
  tipoExamen: string;
  subscription: Subscription;
  subscriptionOpenfilter: Subscription;
  subscriptionfilter: Subscription;
  subscriptionClearfilter: Subscription;
  subscriptionUpdateTabPorEnviar: Subscription;
  tiposExamenPeriodicos: any[] = [];
  tiposExamenReevaluacion: any[] = [];
  tiposExamenPorEnviar: any[] = [];
  @ViewChild( 'sidebar' ) sidebar: Sidebar;
  isConnected = false;
  activeIndex = 0;
  errorSync = false;
  actualizarExamenes = false;
  filtroCargados : any;
  resultadosElements = [{label: 'Por Defecto', value: 'pordefecto'}, {label: 'Personalizada', value: 'personalizada'}];
  displayEmailModal: boolean = false;


  constructor(
    private examenesService: ExamsService,
    private messageAlertServices: MessageAlertService,
    private connectionService: ConnectionService,
    private filterService: FilterService,
    private databaseService: DatabaseService,
    private examsFilterService: ExamsFilterService,
    private backgroundSyncService: BackgroundSyncService,
    private ruta: ActivatedRoute,
    private userEmailService: UserEmailService
  ) {
    this.actualizarExamenes = (ruta.snapshot.params.actualizar === 'true' ? true : false);
  }

  ngOnDestroy(): void {
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
    if ( this.subscriptionOpenfilter ) {
      this.subscriptionOpenfilter.unsubscribe();
    }
    if ( this.subscriptionClearfilter ) {
      this.subscriptionClearfilter.unsubscribe();
    }
    if ( this.subscriptionfilter ) {
      this.subscriptionfilter.unsubscribe();
    }
    if ( this.subscriptionUpdateTabPorEnviar ) {
      this.subscriptionUpdateTabPorEnviar.unsubscribe();
    }
    let esPrimeraCarga = JSON.parse(localStorage.getItem('cargadosIsFirstSearch'));

    let existenFiltrosPreAplicados = !!(JSON.parse(localStorage.getItem('filtrocargados')));

    if(esPrimeraCarga && existenFiltrosPreAplicados ) {
      this.examsFilterService.cleanFilter('cargados');
      this.databaseService.cleanTable('examenesCargados');
    }
  }

  ngOnInit(): void {
    const tabSelected = localStorage.getItem( 'tab' );
    if ( tabSelected ) {
      if ( tabSelected === 'periodicos' ) {
        this.activeIndex = 0;
      } else if ( tabSelected === 'reevaluacion' ) {
        this.activeIndex = 1;
      } else if ( tabSelected === 'cargados' ) {
        this.activeIndex = 2;
      }
      localStorage.removeItem( 'tab' );
    }
    this.filtroCargados = this.examsFilterService.getLocalAdvancedFilter("cargados");
    this.subscriptionsFilter();
    this.getMotivosCierre();
    this.getTiposDictamen();
    this.getTiposCaracterizacionSemiologica();
    this.getNombresEstudio();
    this.getTiposDocumento();
    this.getTiposExamen();
    this.getEspecialidades();
    this.checkUserEmail();


    this.displaySpinnerReevaluacion = false;
    this.displaySpinnerPeriodicos = true;
    this.displaySpinnerCargados = true;
    this.getAllExams(this.actualizarExamenes);
    this.subscriptionUpdateTabPorEnviar = this.backgroundSyncService.updatePorEnviar$.subscribe(
      ( res ) => {
        this.getInfoTabEnviar();
      }
    );
  }

  subscriptionsFilter(): void {
    this.examsFilterService.openFilterExams$.subscribe( ( res ) => {
      this.showPanelFilter( res );
    } );
    this.examsFilterService.filterExams$.subscribe( ( res ) => {
      if (this.sidebar.visible) {
        this.filtrar( res.data, res.tipo );
      }
    } );
    this.examsFilterService.clearFilterExams$.subscribe( ( res ) => {
      this.clearFilter( res );
      this.sidebar.close( new Event( '' ) );
    } );
  }

  /**
   * Método que ejecuta la carga de todos los tipos examenes (periódicos, reevaluación, por enviar)
   */
  async getAllExams(actualizar: boolean): Promise<void> {
    if ( await this.isOnline() ) {
      this.periodicosContent = [];
      this.reevaluacionContent = [];
      this.cargadosContent = [];
      this.periodicosContentTodos = [];
      this.reevaluacionContentTodos = [];
      this.periodicosFiltradosContentTodos = [];
      this.reevaluacionFiltradosContentTodos = [];
      this.cargadosContentTodos = [];
      if(this.examsFilterService.countFilter(this.filtroCargados) > 0) {
        await this.getExamenesCargadosOnline(this.filtroCargados);
      }
      else {
        await this.getExamenesCargadosOffline();
      }
      if (actualizar) {
        await this.getExamenesPeriodicosOnline();
        await this.getReevaluacionOnline();
      } else {
        await this.getExamenesPeriodicosOffline();
        await this.getExamenesReevaluacionOffline();
      }
    } else {
      await this.getExamenesPeriodicosOffline();
      await this.getExamenesReevaluacionOffline();
      await this.getExamenesCargadosOffline();
    }
    this.periodicosFiltradosContentTodos = await this.getAllPeriodicosExamenFiltradosFromOfflineDB();
    this.reevaluacionFiltradosContentTodos = await this.getAllReevaluacionExamenFiltradosFromOfflineDB();
    this.getInfoTabEnviar();
  }

  /**
   * Método que obtiene los tipos de dictamen
   */
  async getTiposDictamen(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getTiposDictamen().subscribe(
        ( response ) => {
          this.databaseService.populateTiposDictamenTable( response.response.tipos );
        },
        ( error ) => {
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  async getTiposCaracterizacionSemiologica(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getTiposCaracterizacionSemiologica().subscribe(
        ( response ) => {
          for ( let index = 0; index < response.response.tipos.length; index++ ) {
            const element = response.response.tipos[ index ];
            let descripcion = '';

            switch ( element.codigo ) {
              case 'GR0':
                descripcion = 'Grado 0';
                break;
              case 'GR1':
                descripcion = 'Grado 1';
                break;
              case 'GR2':
                descripcion = 'Grado 2';
                break;
              case 'GR3':
                descripcion = 'Grado 3';
                break;
              case 'GR4':
                descripcion = 'Grado 4';
                break;
              default:
                break;
            }

            response.response.tipos[ index ] = {
              codigo: element.codigo,
              descripcion: element.descripcion,
              descripcionCodigo: descripcion
            };
          }
          this.databaseService.populateTiposCaracterizacionSemiologica(
            response.response.tipos.sort((a, b) => {
                let fa = a.codigo.toLowerCase(),
                    fb = b.codigo.toLowerCase();
            
                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            })
          );
        },
        ( error ) => {
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  /**
   ** Método que Nombres de los examenes
   */
   async getTiposDocumento(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getTiposDocumento().subscribe(
        ( response ) => {
          this.databaseService.populateTiposDocumentoTable( response.response.tipos );
        },
        ( error ) => {
          console.log('fallo tipo de documentos', error);
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  /**
   ** Método
   */
   async getTiposExamen(): Promise<void> {
    if ( await this.isOnline() ) {
      const tiposExamen = this.examenesService.getTiposExamen()

      this.databaseService.populateTiposExamenTable( tiposExamen );
    }
  }

  /**
   ** Método que Nombres de los estudios
   */
   async getNombresEstudio(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getNombresEstudios().subscribe(
        ( response ) => {
          this.databaseService.populateNombresEstudiosTable( response.response.tipos );
        },
        ( error ) => {
          console.log('fallo nombre examen', error);
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  /**
   * Método que obtiene las especialidades de los médicos
   */
  async getEspecialidades(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getEspecialidades().subscribe(
        ( response ) => {
          this.databaseService.populateEspecialidadesTable( response.response.tipos );
        },
        ( error ) => {
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  /**
   * Método que se encarga de cerrar el examen
   * @param data  {examen, examenPorEnviar} objeto que contiene un objeto de examen y otro de examenPorEnviar (que se agrega a la lista de por enviar)
   * @param tipo  {string} tipo de examen (periodicos, reevaluación..)
   */
  updateExamOnAusente( data: any, tipo: string ): void {
    if ( tipo === 'periodicos' ) {
      this.databaseService.editTableItem(data.examen.id, 'examenesPeriodicosFiltrados', data.examen);
      this.databaseService.editTableItem(data.examen.id, 'examenesPeriodicos', data.examen);
    } else {
      this.databaseService.editTableItem(data.examen.id, 'examenesReevaluacionFiltrados', data.examen);
      this.databaseService.editTableItem(data.examen.id, 'examenesReevaluacion', data.examen);
    }
  }

  /**
   * Método que se encarga de actualizar las listas de examenes periodicos y por enviar
   * @param examen examen periodico a eliminar de la lista
   * @param porEnviar  examen por enviar para agregar a la lista
   */
  updateListsPeriodicos( examen, porEnviar ): void {
    this.periodicosContentTodos.splice(
      this.periodicosContentTodos.indexOf( examen ),
      1
    );
    if (this.periodicosFiltradosContentTodos.indexOf(examen) >= 0) {
      this.periodicosFiltradosContentTodos.splice(
        this.periodicosFiltradosContentTodos.indexOf( examen ),
        1
      );
    }
    this.updateListPorEnviar( porEnviar );
  }

  /**
   * Método que se encarga de actualizar las listas de examenes de reevaluación y por enviar
   * @param examen examen periodico a eliminar de la lista
   * @param porEnviar  examen por enviar para agregar a la lista
   */
  updateListsReevaluacion( examen, porEnviar ): void {
    this.reevaluacionContentTodos.splice(
      this.reevaluacionContentTodos.indexOf( examen ),
      1
    );
    if (this.reevaluacionFiltradosContentTodos.indexOf(examen) >= 0) {
      this.reevaluacionFiltradosContentTodos.splice(
        this.reevaluacionFiltradosContentTodos.indexOf( examen ),
        1
      );
    }
    this.updateListPorEnviar( porEnviar );
  }

  /**
   * Método que se encarga de actualizar la lista de examenes por enviar
   * @param porEnviar
   */
  updateListPorEnviar( porEnviar ): void {
    if ( porEnviar ) {
      const tempPorEnviar = this.enviarContentTodos;
      this.enviarContentTodos = [];
      porEnviar.labelExamen = porEnviar.datosPorEnviar ? porEnviar.datosPorEnviar.labelExamen : null;
      tempPorEnviar.push( porEnviar );
      setTimeout( () => {
        this.enviarContentTodos = tempPorEnviar;
        this.obtenerTiposExamenPorEnviar();
        this.filtroPorEnviar();
      }, 3 );
    }
  }

  filtroPorEnviar() {
    const filtroTemp = localStorage.getItem( 'filtroporEnviar' );
    if ( filtroTemp ) {
      let filto = JSON.parse( filtroTemp );
      this.enviarContent = [ ...this.enviarContentTodos ];
      this.enviarContent = this.examsFilterService.filtradoCustom( this.enviarContent, filto );
    } else {
      this.enviarContent = [ ...this.enviarContentTodos ];
    }
  }

  /**
   * Método que se encarga de refrescar la lista de exámenes después de un cambio ONLINE
   */
  async refreshExamsList(tipo: string): Promise<void> {
    if (tipo === 'periodicos') {
      this.periodicosContent = await this.getAllPeriodicosExamenFromOfflineDB();
    } else if (tipo === 'reevaluacion') {
      this.reevaluacionContent = await this.getAllReevaluacionExamenFromOfflineDB();
    }
  }

  /**
   * Método que se encarga de lanzar el evento para actualizar el contenido de la pagina
   */
  actualizar(): void {
    this.actualizarExamenes = true;
    localStorage.setItem('resultadoPeriodicos', JSON.stringify(this.resultadosElements[0]));
    localStorage.setItem('resultadoReevaluacion', JSON.stringify(this.resultadosElements[0]));
    this.databaseService.clearTableExamanesPeriodicosFiltrados();
    this.databaseService.clearTableExamanesReevaluacionFiltrados();
    this.ngOnInit();
  }

  /**
   * Método para abrir sidebar de filtros avanzados
   * @param event: tipo de examen
   */
  showPanelFilter( event: any ): void {
    this.tipoExamen = event;
    this.display = true;
  }

  closeSidebar( event: boolean ): void {
    this.display = false;
    this.sidebar.hide();
  }

  /**
   * método que obtiene los tipos de examen que estén dentro del listado
   */
  obtenerTiposExamenPeriodicos(): void {
    this.tiposExamenPeriodicos = [
      ...new Set( this.periodicosContentTodos.map( ( item ) => item.tipoEstudio.descripcion ) ),
    ];
    const temp = this.tiposExamenPeriodicos as any;
    this.tiposExamenPeriodicos = [];
    temp.map( ( x ) => {
      this.tiposExamenPeriodicos.push( { value: x, label: x } );
    } );
  }

  /**
   * método que obtiene los tipos de examen que estén dentro del listado
   */
  obtenerTiposExamenReevaluacion(): void {
    this.tiposExamenReevaluacion = [
      ...new Set( this.reevaluacionContentTodos.map( ( item ) => item.tipoEstudio.descripcion ) ),
    ];
    const temp = this.tiposExamenReevaluacion as any;
    this.tiposExamenReevaluacion = [];
    temp.map( ( x ) => {
      this.tiposExamenReevaluacion.push( { value: x, label: x } );
    } );
  }

  /**
   * método que obtiene los tipos de examen que estén dentro del listado
   */
  obtenerTiposExamenPorEnviar(): void {
    this.tiposExamenPorEnviar = [
      ...new Set( this.enviarContentTodos.map( ( item ) => item.tipoEstudio.descripcion? item.tipoEstudio.descripcion : item.tipoEstudio ) ),
    ];
    const temp = this.tiposExamenPorEnviar as any;
    this.tiposExamenPorEnviar = [];
    temp.map( ( x ) => {
      this.tiposExamenPorEnviar.push( { value: x, label: x } );
    } );
  }

  /**
   * método para resetear filtros
   * @param tipo {string}
   */
  clearFilter( tipo: string ): void {
    const isStillOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    switch ( tipo ) {
      case 'periodicos':
        if (isStillOnline) {
          localStorage.setItem('resultadoPeriodicos', JSON.stringify(this.resultadosElements[0]));
          this.databaseService.clearTableExamanesPeriodicosFiltrados();
          this.periodicosContent = [ ...this.periodicosContentTodos ];
        } else {
          const resultado = JSON.parse(localStorage.getItem('resultadoPeriodicos'));
          this.periodicosContent = resultado.value === 'pordefecto' ? [ ...this.periodicosContentTodos ] : [ ...this.periodicosFiltradosContentTodos ];
        }
        break;
      case 'reevaluacion':
        if (isStillOnline) {
          localStorage.setItem('resultadoReevaluacion', JSON.stringify(this.resultadosElements[0]));
          this.databaseService.clearTableExamanesReevaluacionFiltrados();
          this.reevaluacionContent = [ ...this.reevaluacionContentTodos ];
        } else {
          const resultado = JSON.parse(localStorage.getItem('resultadoReevaluacion'));
          this.reevaluacionContent = resultado.value === 'pordefecto' ? [ ...this.reevaluacionContentTodos ] : [ ...this.reevaluacionFiltradosContentTodos ];
        }
        break;
      case 'cargados':
        this.cargadosContentTodos = [];
        this.cargadosContent = [ ...this.cargadosContentTodos ];
        break;
      case 'porEnviar':
        this.enviarContent = [ ...this.enviarContentTodos ];
        break;
    }
  }

  /**
   * Método que se encarga de aplicar el filtro avanzado
   * @param event {objeto} que contiene el filtro a aplicar
   * @param tipo {string} tipo de examen (periodico, reevaluacion, por enviar)
   */
  filtrar( event: any, tipo: string ): void {
    if ( !event ) {
      return;
    }
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    switch ( tipo ) {
      case 'periodicos':
        this.displaySpinnerPeriodicos = true;
        this.getExamenesPeriodicosFiltrados(isOnline, event);
        break;
      case 'reevaluacion':
        this.displaySpinnerReevaluacion = true;
        this.getExamenesReevaluacionFiltrados(isOnline, event);
        break;
      case 'porEnviar':
        this.enviarContent = [ ...this.enviarContentTodos ];
        this.enviarContent = this.examsFilterService.filtradoCustom( this.enviarContent, event );
        break;
      case 'cargados':
        this.filtroCargados = this.examsFilterService.getLocalAdvancedFilter("cargados");
        this.displaySpinnerCargados = true;
        this.getExamenesCargadosOnline(this.filtroCargados);
        break;
    }
  }

  /**
   *  Método que se encarga de obtener el filtro persistido y lanzar el evento de para aplicarlo
   * @param tipo {string} tipo de examen
   */
  aplicarFiltro( tipo: string ): void {
    const filtro = this.examsFilterService.getLocalAdvancedFilter( tipo );
    switch ( tipo ) {
      case 'periodicos':
        if ( this.periodicosContentTodos.length > 0 ) {
          this.filtrar( filtro, tipo );
        } else {
          localStorage.removeItem( 'filtroperiodicos' );
        }
        break;
      case 'reevaluacion':
        if ( this.reevaluacionContentTodos.length > 0 ) {
          this.filtrar( filtro, tipo );
        } else {
          localStorage.removeItem( 'filtroreevaluacion' );
        }
        break;
      case 'porEnviar':
        if ( this.enviarContentTodos.length > 0 ) {
          this.filtrar( filtro, tipo );
        } else {
          localStorage.removeItem( 'filtroporEnviar' );
        }
        break;
    }
  }

  private getExamenesPeriodicosFiltrados(isOnline: boolean, event: any): void {
    if (isOnline && !this.isFiltrosNulos(event) ) {
      this.getExamenesPeriodicosFiltradosOnline(event);
    } else {
      const resultado = JSON.parse(localStorage.getItem('resultadoPeriodicos'));
      this.periodicosContent = resultado.value === 'pordefecto' ? [ ...this.periodicosContentTodos ] : [ ...this.periodicosFiltradosContentTodos ];
      this.periodicosContent = this.examsFilterService.filtradoCustom( this.periodicosContent, event );
      this.displaySpinnerPeriodicos = false;
    }
  }

  private getExamenesPeriodicosFiltradosOnline(event: any): void {
    this.examenesService.getExamenesPeriodicosFiltrados(event)
    .subscribe(
      async ( data ) => {
        if ( data.body.response && data.body.response.estudios.length > 0 ) {
          const itemsOnExamenesPorEnviar = await this.databaseService.getAllExamenesPorEnviarFromOfflineDB();
          const examenesPorEnviar = [];
          itemsOnExamenesPorEnviar.forEach( ( item ) => {
            examenesPorEnviar.push( item.id );
          } );
          data.body.response.estudios = data.body.response.estudios.filter(
            ( item ) => !examenesPorEnviar.includes( item.id )
          );
          data.body.response.estudios.map( ( x ) => {
            if ( x.vigenciaColor === "red" ) {
              x.labelVigencia = 'Mayor a 91 días';
            } else if ( x.vigenciaColor === "green" ) {
              x.labelVigencia = `Menor a 30 días`;
            } else if ( x.vigenciaColor === "yellow" ) {
              x.labelVigencia = `De 31 a 45 días`;
            } else if ( x.vigenciaColor === "orange" ) {
              x.labelVigencia = `De 46 a 90 días`;
            }
            x.categoriaExamen = "periodicos"
            x.provinciaNombreEstudio = x.provinciaNombreEstudio.toUpperCase();
          } );
          await this.databaseService.populateFiltradosPeriodicosExamenTable(
            data.body.response.estudios
          );
          await this.getExamenesPeriodicosFiltradosOffline();
          this.obtenerTiposExamenPeriodicos();
          localStorage.setItem(this.tipoExamen === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion', JSON.stringify(this.resultadosElements[1]));
          this.displaySpinnerPeriodicos = false;
        } else {
          await this.databaseService.clearTableExamanesPeriodicosFiltrados();
          await this.getExamenesPeriodicosFiltradosOffline();
          localStorage.setItem(this.tipoExamen === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion', JSON.stringify(this.resultadosElements[0]));
          this.displaySpinnerPeriodicos = false;
        }
      },
      async ( error ) => {
        this.getExamenesPeriodicosOffline();
      }
    );
  }

  private getExamenesReevaluacionFiltrados(isOnline: boolean, event: any): void {
    if (isOnline) {
      this.getExamenesReevaluacionFiltradosOnline(event);
    } else {
      const resultado = JSON.parse(localStorage.getItem('resultadoReevaluacion'));
      this.reevaluacionContent = resultado.value === 'pordefecto' ? [ ...this.reevaluacionContentTodos ] : [ ...this.reevaluacionFiltradosContentTodos ];
      this.reevaluacionContent = this.examsFilterService.filtradoCustom( this.reevaluacionContent, event );
      this.displaySpinnerReevaluacion = false;
    }
  }

  /**
   * Método que obtiene todos los examenes periodicos online y por enviar offline
   */
   private getExamenesReevaluacionFiltradosOnline(event: any): void {
    this.examenesService.getExamenesReevaluacionFiltrados(event)
    .subscribe(
      async ( data ) => {
        if ( data.body.response && data.body.response.estudios.length > 0 ) {
          const itemsOnExamenesPorEnviar = await this.databaseService.getAllExamenesPorEnviarFromOfflineDB();
          const examenesPorEnviar = [];
          itemsOnExamenesPorEnviar.forEach( ( item ) => {
            examenesPorEnviar.push( item.id );
          } );
          data.body.response.estudios = data.body.response.estudios.filter(
            ( item ) => !examenesPorEnviar.includes( item.id )
          );
          data.body.response.estudios.map( ( x ) => {
            if ( x.vigenciaColor === "red" ) {
              x.labelVigencia = 'Mayor a 31 días';
            } else if ( x.vigenciaColor === "green" ) {
              x.labelVigencia = `Menor a 12 días`;
            } else if ( x.vigenciaColor === "yellow" ) {
              x.labelVigencia = `De 12 a 20 días`;
            } else if ( x.vigenciaColor === "orange" ) {
              x.labelVigencia = `De 21 a 30 días`;
            }
            x.categoriaExamen = "reevaluacion"
            x.provinciaNombreEstudio = x.provinciaNombreEstudio.toUpperCase();
          } );
          await this.databaseService.populateReevaluacionExamenFiltradosTable(
            data.body.response.estudios
          );
          await this.getExamenesReevaluacionFiltradosOffline();
          this.obtenerTiposExamenReevaluacion();
          localStorage.setItem(this.tipoExamen === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion', JSON.stringify(this.resultadosElements[1]));
          this.displaySpinnerReevaluacion = false;
        } else {
          await this.databaseService.clearTableExamanesReevaluacionFiltrados();
          await this.getExamenesReevaluacionFiltradosOffline();
          localStorage.setItem(this.tipoExamen === 'periodicos' ? 'resultadoPeriodicos' : 'resultadoReevaluacion', JSON.stringify(this.resultadosElements[0]));
          this.displaySpinnerReevaluacion = false;
        }
      },
      async ( error ) => {
        await this.getExamenesReevaluacionOffline();
      }
    );
  }

  activeIndexChange( event: any ): void {
    this.activeIndex = event;
  }

  /**
   * Método porque verifica conexión  (online- offline)
   */
  private async isOnline(): Promise<boolean> {
    const isOnline = await (
      await this.databaseService.getOnlineStatusFromOfflineDB()
    ).isStillOnline;
    return isOnline;
  }

  /**
   * Método que obtiene todos los examenes periodicos offline
   */
  private async getAllPeriodicosExamenFromOfflineDB(): Promise<any> {
    const examensListData = await await this.databaseService.getAllPeriodicosExamenFromOfflineDB();
    return await examensListData;
  }

  /**
   * Método que obtiene todos los examenes periodicos filtrados offline
   */
   private async getAllPeriodicosExamenFiltradosFromOfflineDB(): Promise<any> {
    const examensListData = this.databaseService.getAllPeriodicosExamenFiltradosFromOfflineDB();
    return examensListData;
  }

  /**
   * Método que se encarga de obtener todos los examenes de reevaluación de la base de datos offline
   * @private
   */
  private async getAllReevaluacionExamenFromOfflineDB(): Promise<any> {
    const examensListData = await await this.databaseService.getAllReevaluacionExamenFromOfflineDB();
    return await examensListData;
  }

  /**
   * Método que se encarga de obtener todos los examenes de reevaluación de la base de datos offline
   * @private
   */
   private async getAllReevaluacionExamenFiltradosFromOfflineDB(): Promise<any> {
    const examensListData = await this.databaseService.getAllReevaluacionExamenFiltradosFromOfflineDB();
    return await examensListData;
  }

  /**
   * Método que obtiene todos los examenes cargados offline
   */
  private async getAllCargadosExamenFromOfflineDB(): Promise<any> {
    const examensListData = await await this.databaseService.getAllCargadosExamenFromOfflineDB();
    return await examensListData;
  }

  /**
   * Método que obtiene todos los examenes periodicos online y por enviar offline
   */
  private async getExamenesPeriodicosOnline(): Promise<void> {
    // await this.getExamenesPeriodicosOffline();
    this.examenesService.getExamenesPeriodicos().subscribe(
      async ( data ) => {
        if ( data.body.response && data.body.response.estudios.length > 0 ) {
          const itemsOnExamenesPorEnviar = await this.databaseService.getAllExamenesPorEnviarFromOfflineDB();
          const examenesPorEnviar = [];
          itemsOnExamenesPorEnviar.forEach( ( item ) => {
            examenesPorEnviar.push( item.id );
          } );
          data.body.response.estudios = data.body.response.estudios.filter(
            ( item ) => !examenesPorEnviar.includes( item.id )
          );
           data.body.response.estudios.map( ( x ) => {
            if ( x.vigenciaColor === "red" ) {
              x.labelVigencia = 'Mayor a 91 días';
            } else if ( x.vigenciaColor === "green" ) {
              x.labelVigencia = `Menor a 30 días`;
            } else if ( x.vigenciaColor === "yellow" ) {
              x.labelVigencia = `De 31 a 45 días`;
            } else if ( x.vigenciaColor === "orange" ) {
              x.labelVigencia = `De 46 a 90 días`;
            }
            x.categoriaExamen = "periodicos"
            x.provinciaNombreEstudio = x.provinciaNombreEstudio.toUpperCase();
          } );

          await this.databaseService.populatePeriodicosExamenTable(
            data.body.response.estudios
          );
          await this.getExamenesPeriodicosOffline();

          this.obtenerTiposExamenPeriodicos();
          this.aplicarFiltro( 'periodicos' );
          this.displaySpinnerPeriodicos = false;
        } else {
          localStorage.removeItem( 'filtroperiodicos' );
          await this.databaseService.populatePeriodicosExamenTable( [] );
          this.displaySpinnerPeriodicos = false;
        }
      },
      async ( error ) => {
        this.getExamenesPeriodicosOffline();
      }
    );
  }

  /**
   * Método que obtiene todos los examenes periodicos online y por enviar offline
   */
  private getReevaluacionOnline(): void {
    this.reevaluacionContent = [];
    this.examenesService.getExamenesReevaluacion().subscribe(
      async ( data ) => {
        if ( data.body.response && data.body.response.estudios.length > 0 ) {
          const itemsOnExamenesPorEnviar = await this.databaseService.getAllExamenesPorEnviarFromOfflineDB();
          const examenesPorEnviar = [];
          itemsOnExamenesPorEnviar.forEach( ( item ) => {
            examenesPorEnviar.push( item.id );
          } );
          data.body.response.estudios = data.body.response.estudios.filter(
            ( item ) => !examenesPorEnviar.includes( item.id )
          );
           data.body.response.estudios.map( ( x ) => {
            if ( x.vigenciaColor === "red" ) {
              x.labelVigencia = 'Mayor a 31 días';
            } else if ( x.vigenciaColor === "green" ) {
              x.labelVigencia = `Menor a 12 días`;
            } else if ( x.vigenciaColor === "yellow" ) {
              x.labelVigencia = `De 12 a 20 días`;
            } else if ( x.vigenciaColor === "orange" ) {
              x.labelVigencia = `De 21 a 30 días`;
            }
            x.categoriaExamen = "reevaluacion"
            x.provinciaNombreEstudio = x.provinciaNombreEstudio.toUpperCase();
          } );

          await this.databaseService.populateReevaluacionExamenTable(
            data.body.response.estudios
          );

          await this.getExamenesReevaluacionOffline();
          this.obtenerTiposExamenReevaluacion();
          this.aplicarFiltro( 'reevaluacion' );
          this.displaySpinnerReevaluacion = false;
        } else {
          localStorage.removeItem( 'filtroreevaluacion' );
          await this.databaseService.populateReevaluacionExamenTable( [] );
          this.displaySpinnerReevaluacion = false;
        }
      },
      async ( error ) => {
        await this.getExamenesReevaluacionOffline();
      }
    );
  }

  /**
  * Método que obtiene todos los examenes periodicos online y por enviar offline
  */
 private async getExamenesCargadosOnline(filtro): Promise<void> {
  this.examenesService.getExamenesCargados(filtro).subscribe(
    async (results) => {
      if (results.body.response && results.body.response.estudios.length > 0) {
        //* 1 - si me llego data popular la tabla
        results.body.response.estudios.forEach(item => {
          item.examenGroup = 'cargados';
          item.provinciaNombreEstudio = item.provinciaNombreEstudio.toUpperCase();
        });

        //* 2 - llenar la tabla de la offline DB
        await this.databaseService.populateCargadosExamenTable(
          results.body.response.estudios
        );

        this.examsFilterService.setFilter({ data: filtro, tipo: "cargados" });

        this.cargadosContent = await this.getAllCargadosExamenFromOfflineDB();
        this.cargadosContentTodos = [ ...this.cargadosContent ];

        this.displaySpinnerCargados = false;

      } else {
        await this.databaseService.populateCargadosExamenTable([]);
        this.examsFilterService.setFilter({ data: filtro, tipo: "cargados" });

        this.displaySpinnerCargados = false;
      }
    },
    async (error) => {
      this.getExamenesCargadosOffline;
    }
  );
 }

  /**
   * Método que se encarga de obtener todos los examenes periodicos de la base de datos offline
   * si existen datos en la tabla de filtrados, los trae de ahi porque se supone que está filatrada
   * la data
   */
  private async getExamenesPeriodicosOffline(): Promise<void> {
    if (await this.databaseService.getCountPeriodicosExamenFiltradosFromOfflineDB() > 0
    && JSON.parse(localStorage.getItem('resultadoPeriodicos')).value !== 'pordefecto') {
      this.periodicosContentTodos = await this.getAllPeriodicosExamenFromOfflineDB();
      this.periodicosContent = await this.getAllPeriodicosExamenFiltradosFromOfflineDB();
    } else {
      this.periodicosContentTodos = await this.getAllPeriodicosExamenFromOfflineDB();
      this.periodicosContent = [ ...this.periodicosContentTodos ];
      this.aplicarFiltro( 'periodicos' );
    }
    this.displaySpinnerPeriodicos = false;
    this.obtenerTiposExamenPeriodicos();
  }

  /**
   * Método que se encarga de obtener todos los examenes periodicos filtrados de la base de  datos offline
   * @private
   */
   private async getExamenesPeriodicosFiltradosOffline(): Promise<void> {
    this.periodicosContent = await this.getAllPeriodicosExamenFiltradosFromOfflineDB();
    this.periodicosFiltradosContentTodos = this.periodicosContent;
  }

  /**
   * Método que se encarga de obtener todos los examenes de reevaluación de la base de  datos offline
   * @private
   */
  private async getExamenesReevaluacionOffline(): Promise<void> {
    if (await this.databaseService.getCountReevaluacionExamenFiltradosFromOfflineDB() > 0
    && JSON.parse(localStorage.getItem('resultadoReevaluacion')).value !== 'pordefecto') {
      this.reevaluacionContentTodos = await this.getAllReevaluacionExamenFromOfflineDB();
      this.reevaluacionContent = await this.getAllReevaluacionExamenFiltradosFromOfflineDB();
    } else {
      this.reevaluacionContent = await this.getAllReevaluacionExamenFromOfflineDB();
      this.reevaluacionContentTodos = [ ...this.reevaluacionContent ];
      this.aplicarFiltro( 'reevaluacion' );
    }
    this.displaySpinnerReevaluacion = false;
    this.obtenerTiposExamenReevaluacion();
  }

  /**
   * Método que se encarga de obtener todos los examenes de reevaluación filtrados de la base de  datos offline
   * @private
   */
   private async getExamenesReevaluacionFiltradosOffline(): Promise<void> {
    this.reevaluacionContent = await this.getAllReevaluacionExamenFiltradosFromOfflineDB();
    this.reevaluacionFiltradosContentTodos = this.reevaluacionContent;
  }

  /**
   * Método que se encarga de obtener todos los examenes cargados de la base de  datos offline
   * @private
   */
  private async getExamenesCargadosOffline(): Promise<void> {
    this.cargadosContent = await this.getAllCargadosExamenFromOfflineDB();
    this.cargadosContentTodos = [ ...this.cargadosContent ];

    this.aplicarFiltro( 'cargados' );

    this.displaySpinnerCargados = false;
  }

  async updateCargados($event: boolean) {
    this.displaySpinnerCargados = true;
    if (this.tipoExamen === 'cargados' && $event) {

      if ( this.sidebar ) {
        this.sidebar.hide();
        this.sidebar.close( new Event( '' ) );
      }

      await this.getExamenesCargadosOffline();
    }
  }

  /**
   * Método que se encarga de obtener todos los examenes por enviar de la base de datos offline
   * @private
   */
  private async getInfoTabEnviar(): Promise<void> {
    const exams = await this.databaseService.getAllExamenesPorEnviarFromOfflineDB();
    this.mapPorEnviar( exams );
  }

  /**
   * Método que se encarga de mapear la lista de examenes por enviar
   * @param exams lista de examenes por enviar como los retrona la base de datos offline
   * @private
   */
  private mapPorEnviar( exams: any ): void {
    const listTemp = [];
    exams.map( ( obj ) => {
      listTemp.push( this.examenesService.buildObjetPorEnviar( obj ) );
    } );
    this.enviarContent = listTemp;
    this.enviarContentTodos = listTemp;
    this.errorSync = exams.filter( ( x ) => x.error ).length > 0;
    this.obtenerTiposExamenPorEnviar();
    this.aplicarFiltro( 'porEnviar' );
  }

  /**
   * Método que obtiene los motivos de cierre
   */
  private async getMotivosCierre(): Promise<void> {
    this.getMotivosCierreFromService();
  }

  /**
   * Método que obtiene los motivos de cierre online
   */
  private async getMotivosCierreFromService(): Promise<void> {
    if ( await this.isOnline() ) {
      this.examenesService.getMotivosCierre().subscribe(
        ( response ) => {
          this.databaseService.updateMotivosCierreOnOfflineDB( response.response.tipos );
        },
        ( error ) => {
          this.messageAlertServices.setMessage( 0, {
            severity: 'error',
            summary: '',
            detail: error.error.response
              .map( ( x ) => {
                return x.message;
              } )
              .join( ', ' ),
            key: 'examen',
          } );
        }
      );
    }
  }

  private isFiltrosNulos(filtro: any): boolean {
    return (
      filtro.labelVigencia.length === 0
      && filtro.labelExamen === null
      && filtro.tipoExamen === null
      && filtro.contrato === null
    );
  }

  private async changeResultados($event) {
    if ($event === 'periodicos') {
      this.displaySpinnerPeriodicos = true;
      const resultado = JSON.parse(localStorage.getItem('resultadoPeriodicos'));
      this.periodicosContent = resultado.value === 'pordefecto'
                               ? this.periodicosContentTodos
                               : this.periodicosFiltradosContentTodos;
      this.displaySpinnerPeriodicos = false;
    } else {
      this.displaySpinnerReevaluacion = true;
      const resultado = JSON.parse(localStorage.getItem('resultadoReevaluacion'));
      this.reevaluacionContent = resultado.value === 'pordefecto'
                               ? this.reevaluacionContentTodos
                               : this.reevaluacionFiltradosContentTodos;
      this.displaySpinnerReevaluacion = false;
    }
  }

  private async checkUserEmail(): Promise<void> {
    if ( await this.isOnline() ) {
      this.userEmailService.checkUserEmail().subscribe(
        (response) => {
          const email = response?.response?.email;
          const hasEmail = email && email.trim() !== '';
          if (!hasEmail) {
            this.displayEmailModal = true;
          }
        },
        (error) => {
          console.error('Error al verificar correo del usuario', error);
        }
      );
    }
  }

}
